// extracted by mini-css-extract-plugin
export default {"container":"Select_container__L58Uf","dropdown":"Select_dropdown__Hrya9","collapsed":"Select_collapsed__iCx6V","expanded":"Select_expanded__KWosK"};